import { languageMap } from ".."

languageMap.robot = languageMap.robotframework = {
	comments: {
		line: "#",
	},
}
